import TechnicalRoundOverallRoundScore from './TechnicalRoundOverallRoundScore';
import TechnicalRoundInterviewedBy from './TechnicalRoundInterviewedBy';
import TechnicalRoundInterviewedOn from './TechnicalRoundInterviewedOn';
import { useThemeContext } from 'src/context/ThemeProvider';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	data: {
		overallRoundScore: number;
		skillsAssesed: string[];
		interviewedByData: {
			name: string;
			img: string;
			company: string;
			role: string;
			linkedinUrl: string;
		};
		interviewedOnData: {
			duration: number;
			startTime: string;
		};
	};
}

const RoundDetails = ({ data }: Props) => {
	const { isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();
	const { themeMode } = useThemeContext();
	return (
		<>
			<div
				className="flex bg-white dark:bg-[#18222D] rounded-[8px] border border-solid border-[#e5ffff1a] px-4 py-5 justify-around sm:flex-col sm:gap-5 "
				style={
					themeMode === 'dark'
						? {
								background:
									'linear-gradient(#1f2a37, #1f2a37) padding-box, linear-gradient(to right, #5b8def, #0063f7, #73dfe7, #0063f7) border-box',
								border: '1px solid transparent',
						  }
						: {
								filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.10)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.10))',
								background:
									'linear-gradient(#ffff, #ffff) padding-box, linear-gradient(to right, #5b8def, #0063f7, #73dfe7, #0063f7) border-box',
								border: '1px solid transparent',
						  }
				}
			>
				{isRecruiterLoggedIn || isAccountManagerLoggedIn ? (
					<div className='w-full'>
						<TechnicalRoundOverallRoundScore score={data.overallRoundScore} />
					</div>
				) : null}

				{/* commenting for now */}
				{/* <TechnicalRoundSkillsAssessed skills={data.skillsAssesed} /> */}
				<div className="w-full">
					<TechnicalRoundInterviewedBy interviewedBy={data.interviewedByData} />
				</div>
				<div className="w-full">
					<TechnicalRoundInterviewedOn interviewedOn={data.interviewedOnData} />
				</div>
			</div>
		</>
	);
};

export default RoundDetails;
